import React from 'react'
import deepEqual from 'fast-deep-equal'
import { BidHistoryTooltip } from '../bid_history_tooltip'
import { axiosPatch } from '../../util/api'
import { Toasts } from '../toaster/Toast'
import { UpdateReportAdTypes } from '../../util/contstants'
import { InlineEditPopover } from '../bids/InlineEditPopover'

interface DefaultBidChangeProps {
    ad_group: any
    extra: any
    disabled: boolean
}

export class DefaultBidChange extends React.Component<DefaultBidChangeProps> {
    shouldComponentUpdate(nextProps: Readonly<DefaultBidChangeProps>): boolean {
        return (
            !deepEqual(nextProps.ad_group, this.props.ad_group) ||
            !deepEqual(nextProps.extra, this.props.extra)
        )
    }

    render(): JSX.Element {
        const { ad_group, extra, disabled } = this.props

        return (
            <BidHistoryTooltip
                id={ad_group.ad_group_id}
                type={UpdateReportAdTypes.AdGroups}
                campaign_id={ad_group.campaign_id}
                bid={ad_group.default_bid}
                bidLimits={ad_group.bid_limits}
            >
                <InlineEditPopover
                    disabled={disabled}
                    label="Default bid"
                    value={ad_group.default_bid}
                    onSave={(cents) => updateDefaultBid(ad_group.ad_group_id, cents, extra)}
                />
            </BidHistoryTooltip>
        )
    }
}

const updateDefaultBid = (id: number, default_bid: number, extra: any) =>
    axiosPatch(`ad-groups/${id}`, { default_bid })
        .then(() => {
            Toasts.success('Default Bid successfully updated')
            extra.reload()
        })
        .catch((err) => {
            if (err.response?.status === 409) {
                const ids = Object.keys(err.response.data)

                Toasts.warning(
                    `${ids.length} items were out of sync. Please review the changes and retry`,
                )
                extra.reload()
            }
            throw err
        })
